import { Box } from '@mui/material';

import TopBar from '@/components/common/TopBar';
import Sidebar from '@/components/common/Sidebar';
import MapMain from '@/components/common/MapMain';
import DeviceDetail from '@/components/devices/DeviceDetail';
import ReportSnackbar from '@/components/common/ReportSnackbar';

export default function MainTemplates({ children }: Readonly<{ children: React.ReactNode }>) {
  return (
    <>
      <TopBar />
      <Box sx={{ flexGrow: 1, display: 'flex' }}>
        <Sidebar />
        <Box component="main" sx={{ flexGrow: 1, position: 'relative', overflow: 'hidden' }}>
          <MapMain />
          {children}
          <DeviceDetail />
          <ReportSnackbar />
        </Box>
      </Box>
    </>
  );
}
